import * as React from "react";

export type Img = {
  default: string;
  height?: number;
  width?: number;
};

type Props = {
  src: Img;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  maxHeight?: number;
};

export function SvgStaticImage(props: Props) {
  const aria = props.alt == "" ? { role: "presentation" } : {};
  return (
    <img
      alt={props.alt}
      {...aria}
      className={props.className}
      style={{
        maxWidth: "100%",
        height: "auto",
        ...(props.maxHeight ? { maxHeight: props.maxHeight } : {}),
      }}
      loading="lazy"
      height={props.height ?? props.src.height}
      width={props.width ?? props.src.width}
      src={props.src.default}
    />
  );
}
